import { render, staticRenderFns } from "./CheckoutOverview.vue?vue&type=template&id=58fb4c36&scoped=true"
import script from "./checkoutOverview.ts?vue&type=script&lang=ts&external"
export * from "./checkoutOverview.ts?vue&type=script&lang=ts&external"
import style0 from "./CheckoutOverview.vue?vue&type=style&index=0&id=58fb4c36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fb4c36",
  null
  
)

export default component.exports